import { slugifyRu } from "@/shared/utils/portfolioSlug";

export function previewTenantSlug(companyName: string): string {
    return slugifyRu(companyName);
}

export function getTenantBaseDomain(): string {
    return process.env.NEXT_PUBLIC_ENV === "prod" ? "tezam.by" : "dev.tezam.by";
}

export function previewTenantDomain(companyName: string): string {
    const slug = previewTenantSlug(companyName);
    if (!slug) return "";
    return `${slug}.${getTenantBaseDomain()}`;
}
